$(document).ready(function () {
    'use strict';

    // --shop-filer tab js start--
    $('.shop-filer-nav:first-child').addClass('active');
    $('.shop-content-items').hide();
    $('.shop-content-items:first-child').show();

    $('.shop-filer-nav').click(function () {
        $('.shop-filer-nav').removeClass('active');
        $(this).addClass('active');
        $('.shop-content-items').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });

    $("#toTop").click(function () {
        $("html, body").animate({scrollTop: 0}, 1000);
     });

    
    // --shop-filer tab js end--

    // --featured-product tab js start--
    $('.featured-product-nav:first-child').addClass('active');
    $('.featured-product-item').hide();
    $('.featured-product-item:first-child').show();

    $('.featured-product-nav').click(function () {
        $('.featured-product-nav').removeClass('active');
        $(this).addClass('active');
        $('.featured-product-item').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });
    // --featured-product tab js end--

    $(".icon-accordions-heading").on('click', function () {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
     });
})
